// Author liang gang qiang
// Date 2023-09-08 12:20:26

class SithMomMaterialDrawingDownloadRecord {
constructor({
        id = null,
        drawingId = '',
        downloadBy = '',
        downloadTimes = '',
        remark = ''}
= {}) {
    this.id = id;
    this.drawingId = drawingId;
    this.downloadBy = downloadBy;
    this.downloadTimes = downloadTimes;
    this.remark = remark;
}
}

function newEntity() {
return new SithMomMaterialDrawingDownloadRecord();
}

const summaryModeVoConfigs = [
        {
        key: 'downloadUserName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadUserName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'downloadBy',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadBy',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '单文件下载' },
                            { value: '2', text: 'BOM连带下载' },
                            { value: '3', text: '批量下载' }
            ]
                }
        },
        {
        key: 'downloadTimes',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadTimes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'drawingId',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.drawingId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'downloadBy',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadBy',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '单文件下载' },
                            { value: '2', text: 'BOM连带下载' },
                            { value: '3', text: '批量下载' }
            ]
                }
        },
        {
        key: 'downloadTimes',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadTimes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'downloadUserName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadUserName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}
const recordModeVoConfigs = [
        {
        key: 'downloadUserName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadUserName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'downloadBy',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.downloadBy',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '单文件下载' },
                            { value: '2', text: 'BOM连带下载' },
                            { value: '3', text: '批量下载' }
            ]
                }
        },
        {
        key: 'createdTime',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    drawingIdFilter : '',
    downloadByFilter : '',
    downloadTimesFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'drawingIdFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.filter.drawingId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'downloadByFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.filter.downloadBy',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'downloadTimesFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.filter.downloadTimes',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'drawingId',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.entity.drawingId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'downloadBy',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.entity.downloadBy',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'downloadTimes',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.entity.downloadTimes',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingDownloadRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMaterialDrawingDownloadRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs

, summaryModeVoConfigs, recordModeVoConfigs
}
